import type React from "react";
import styles from "./index.module.scss";

interface TutorialTooltipProps {
  children: React.ReactNode;
  message: string;
  position?: "top" | "bottom" | "left" | "right";
}

export const TutorialTooltip: React.FC<TutorialTooltipProps> = ({
  children,
  message,
  position = "top",
}) => {
  return (
    <div className={styles["tooltipWrapper"]}>
      {children}
      <div className={`${styles["tooltip"]} ${styles[position]}`}>
        <span className={styles["tooltipText"]}>{message}</span>
      </div>
    </div>
  );
};
